// extracted by mini-css-extract-plugin
export var button = "_6o-4";
export var hasDarkBackground = "_6o-7";
export var hasLightBackground = "_6o-6";
export var iconWrapper = "_6o-0";
export var large = "_6o-2";
export var medium = "_6o-1";
export var small = "_6o-5";
export var xsmall = "_6o-3";